import React from "react";
import "./Styles/why-choose-us.css";
import fastDelivery from "../Images/livraison-rapide.png"
import debitCard from "../Images/carte-de-debit.png"
import dollarSymbol from "../Images/dollar-symbol.png"
import bubbleChat from "../Images/bubble-chat.png"
import idCard from "../Images/id-card.png"

export const WhyChooseUs = () => {
    
    return (
        <div className="wcu-container">
            <div className="wcu-item">
                <img src={fastDelivery} alt="fastDelivery"/>
                <span><strong>Livraison Gratuite</strong><br />Pour toute commande de plus de 75.000 F</span>
            </div>
            <div className="wcu-item">
                <img src={debitCard} alt="debitCard" />
                <span><strong>Paiement Sécurisé</strong><br />Paiement 100% sécurisé</span>
            </div>
            <div className="wcu-item">
                <img src={dollarSymbol} alt="dollar" />
                <span><strong>Magasinez en toute confiance</strong><br />Si les marchandises ont des problèmes</span>
            </div>
            <div className="wcu-item">
            <img src={bubbleChat} alt="chat" />
            <span><strong>Centre d'aide 24/7</strong><br />Assistance dédiée 24h/24 et 7j/7</span>
            </div>
            <div className="wcu-item">
            <img src={idCard} alt="id" />
            <span><strong>Services Conviviaux</strong><br />Garantie de satisfication de 30 jours</span>
            </div>   
        </div>
    )
}